import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { A11yModule } from "@angular/cdk/a11y";

import { MatCommonModule, MatNativeDateModule, MAT_DATE_LOCALE, } from "@angular/material/core";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSliderModule } from "@angular/material/slider";
import { MatSelectModule } from "@angular/material/select";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { ShellModule } from "../shell/shell.module";
import { InfosModule } from "../module-infos/infos.module";
import { LazyLoadStylesheetService } from "../services/lazy-load-stylesheet.service";

import { EditWayPointsComponent } from "./edit-waypoints/edit-waypoints.component";
import { MapsComponent } from "./maps/maps.component";
import { GeneralPopupComponent } from "../global-components/popup-general/popup-general.component";
import { RouteNamePopupComponent } from "./popup-route-name/popup-route-name.component";
import { MissingLocatorPopupComponent } from "./popup-missing-locator/popup-missing-locator.component";
import { NaviProfileChartComponent } from "./show-details/navi-profile-chart/navi-profile-chart.component";
import { NavigationMonitorComponent } from "./navigation-monitor/navigation-monitor.component";
import { PresentRouteStripeComponent } from "./present-route-stripe/present-route-stripe.component";
import { PresentSingleRouteCardComponent } from "./present-single-route-card/present-single-route-card.component";
import { BottomSheetSearchFilterComponent } from "./bottom-sheet-search-filter/bottom-sheet-search-filter.component";
import { BottomSheetRoutePlannerComponent } from "./bottom-sheet-route-planner/bottom-sheet-route-planner.component";
import { BottomSheetRouteFormatComponent } from "./bottom-sheet-route-format/bottom-sheet-route-format.component";
import { SharedModule } from "../module-shared/shared.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { PresentSingleRouteSimpleComponent } from "../module-shared/present-single-route-simple/present-single-route-simple.component";
import { GpxRouteComponent } from "./gpx-route/gpx-route.component";
import { MapSelectionComponent } from "./map-selection/map-selection.component";
import { SearchPlace1Component } from "./search-place/search-place.component";
import { SearchPoisFilterComponent } from "./search-pois-filter/search-pois-filter.component";
import { ManageMapsComponent } from "./manage-maps/manage-maps.component";
import { TrackingComponent } from "./tracking/tracking.component";
import { ShowRouteComponent } from "../module-shared/show-route/show-route.component";
import { MapsAdminComponent } from "../module-main/maps-admin/maps-admin.component";
import { PublishRouteComponent } from "./publish-route/publish-route.component";
import { RateRouteComponent } from "./rate-route/rate-route.component";
import { ShowTrackComponent } from "./show-details/show-track/show-track.component";
import { PublishRouteCollectionComponent } from "../module-shared/publish-route-collection/publish-route-collection.component";
import { MatDividerModule } from "@angular/material/divider";
import { BottomSheetRouteDetailsComponent } from "../module-shared/bottom-sheet-route-details/bottom-sheet-route-details.component";

const routes: Routes = [
  // { path: "", component: MapsComponent },
  // { path: "planner", component: MapsComponent },
];

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    BottomSheetRouteFormatComponent,
    BottomSheetRoutePlannerComponent,
    BottomSheetRouteDetailsComponent,
    BottomSheetRouteFormatComponent,
    BottomSheetSearchFilterComponent,
    EditWayPointsComponent,
    GeneralPopupComponent,
    MissingLocatorPopupComponent,
    NavigationMonitorComponent,
    NaviProfileChartComponent,
    RouteNamePopupComponent,
    SearchPlace1Component,

    MapsComponent,
    GpxRouteComponent,
    ManageMapsComponent,
    MapSelectionComponent,
    PresentRouteStripeComponent,
    PresentSingleRouteCardComponent,
    PublishRouteComponent,
    RateRouteComponent,
    SearchPoisFilterComponent,
    ShowTrackComponent,
    TrackingComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    // BackButtonDisableModule.forRoot({
    //   preserveScrollPosition: true
    // }),
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    MatAutocompleteModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    // MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatSliderModule,
    DragDropModule,

    A11yModule,

    ShellModule,
    // InfosModule,
    SharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // wichtig für Custom Elements
  providers: [
    // { provide: LOCALE_ID, useValue: "en-GB" },
    // { provide: MAT_DATE_LOCALE, useValue: "en-GB" },

    LazyLoadStylesheetService,
  ],
  exports: [
    RouterModule,

    MissingLocatorPopupComponent,
    NavigationMonitorComponent,
    NaviProfileChartComponent,
    SearchPlace1Component,

    MapsComponent,
    GpxRouteComponent,
    ManageMapsComponent,
    MapSelectionComponent,
    PresentRouteStripeComponent,
    PresentSingleRouteCardComponent,
    PublishRouteComponent,
    RateRouteComponent,
    SearchPoisFilterComponent,
    ShowTrackComponent,
    TrackingComponent,

  ]
})
export class MapsModule {

}
